<template>
  <div class="pb-12">
    <div class="relative bg-white rounded-full flex items-center justify-center h-32 w-32 mx-auto -mt-12">
      <SvgCompassLoader class="w-3/5" />
    </div>
    <div class="px-3 xs:px-8">
      <Input
        label="From" ref="from" :focused="focusedInput === 'from'" @focus="handleFocusInput('from')" @clear="fromAirport = null"
        :selected-airport="fromAirport" tabindex="0" :class="!estimate ? 'mt-8' : 'mt-4'" v-slot:input-right
      >
        <CurrentLocation v-if="!fromAirport" @change="handleCurrentLocation" />
      </Input>
      <Input
        label="To" ref="to" :focused="focusedInput === 'to'" @focus="handleFocusInput('to')" @clear="toAirport = null"
        :selected-airport="toAirport" tabindex="0" class="mt-4"
      />
      <div class="relative">
        <TransitionFadeSlideUp>
          <button v-if="!estimate" class="py-5 mt-4 bg-taupe-400 uppercase font-medium text-lg text-white w-full absolute top-0">
            Estimate
          </button>
        </TransitionFadeSlideUp>
      </div>
    </div>

    <TransitionFadeSlideUp>
      <SvgCompassLoader v-if="estimateLoading" :animated="true" class="w-16 mx-auto mt-12" />
      <Estimate
        v-else-if="Array.isArray(estimate) && estimate.length"
        :data="estimate"
        :slidesPerView="twMd ? 2 : 1"
        :swipable="true"
        class="mt-6"
      />
    </TransitionFadeSlideUp>

    <TransitionFadeSlideUp>
      <div v-if="focusedInput" class="fixed z-40 inset-0 bg-white">
        <div class="bg-taupe-400 py-5 px-3 xs:px-8 flex items-center text-white">
          <button @click="focusedInput = null">
            <SvgArrowLeft class="h-4"  />
          </button>
          <p class="font-medium ml-4">Choose your {{ focusedInput === 'from' ? 'departure' : 'arrival' }}</p>
        </div>
        <Input
          :label="focusedInput" ref="input" @focus="focused = true" @blur="focused = false" :focused="focused"
          v-model="input" @clear="handleClear"
          :selected-airport="selectedAirport" v-slot:input-right input-class="px-3 xs:px-8" label-class="ml-3 xs:ml-8"
        >
          <CurrentLocation v-if="focusedInput === 'from' && !fromAirport" @change="handleCurrentLocation" />
        </Input>
        <div class="relative">
          <TransitionFadeSlideUp>
            <div
              v-if="places.length || suggestedAirports.length"
              class="absolute top-0 inset-x-0 flex flex-col bg-grey-100"
            >
              <PlaceList
                v-if="places.length"
                :style="`order: ${order.indexOf('places')}`"
                @select="handleSelectAirport"
              />
              <ul
                v-if="suggestedAirports.length"
                class="border-b border-grey-200"
                :style="`order: ${order.indexOf('airports')}`"
              >
                <li class="py-1 px-4 bg-grey-100 text-grey-500 uppercase tracking-wider text-sm font-medium">Airports</li>
                <AirportItem
                  v-for="(airport, index) in suggestedAirports"
                  :key="`airport-${index}`"
                  :airport="airport"
                  @select="handleSelectAirport"
                />
              </ul>
            </div>
            <div v-else class="flex flex-col items-center">
              <SvgCompassLoader class="mt-16 w-16" />
              <p class="mt-4 text-grey-400">Please enter a {{ focusedInput === 'from' ? 'departure' : 'arrival' }} airport</p>
            </div>
          </TransitionFadeSlideUp>
        </div>
      </div>
    </TransitionFadeSlideUp>
  </div>
</template>

<script>
import sidebarMixin from '@/mixins/sidebar'
import TransitionHeight from '@/components/transitions/Height'
import TransitionFadeSlideUp from '@/components/transitions/FadeSlideUp'
import SvgArrowLeft from '@/components/svg/ArrowLeft'

export default {
  mixins: [sidebarMixin],
  components: { TransitionHeight, TransitionFadeSlideUp, SvgArrowLeft },
  data () {
    return {
      // Tailwind md breakpoint
      twMd: window.innerWidth >= 768,
      focused: false,
      input: '',
    }
  },
  computed: {
    selectedAirport () {
      return this[`${this.focusedInput}Airport`]
    }
  },
  watch: {
    input (val) {
      this.inputHandler(this.focusedInput, val)
    },
  },
  methods: {
    handleFocusInput (focused) {
      this.focusedInput = focused
      this.$nextTick(() => {
        this.$refs.input.$el.children[1].focus()
      })
    },
    handleClear (input) {
      this[input + 'Airport'] = null
      this.input = null
      this.focusedInput = null
    },
    handleSelectAirport (airport) {
      if (! (airport.is_open && (airport.jetfly_pc12_operability !== 'unoperable' || airport.jetfly_pc24_operability !== 'unoperable' || airport.jetfly_sf50_operability !== 'unoperable'))) return
      this[this.focusedInput + 'Airport'] = airport
      this.input = null
      this.places = []
      this.suggestedAirports = []
      this.order = []
      this.focusedInput = null
    }
  }
}
</script>
